import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Send, CheckCircle } from 'lucide-react';
import { ctaContent } from '../../data/mock';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const CTA = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Por favor, preencha todos os campos');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${API}/quote`, formData);
      
      if (response.data.status === 'success') {
        toast.success('Pedido enviado com sucesso! Entraremos em contacto brevemente.');
        setFormData({ name: '', email: '', message: '' });
      }
    } catch (error) {
      console.error('Error sending quote request:', error);
      toast.error('Erro ao enviar pedido. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-slate-900 p-8 lg:p-16">
          {/* Background Elements */}
          <div className="absolute inset-0">
            <div className="absolute top-0 right-0 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />
          </div>
          
          {/* Content */}
          <div className="relative z-10">
            <div className="text-center max-w-2xl mx-auto mb-10">
              <Badge className="mb-6 bg-teal-500/20 text-teal-300 border-teal-500/30 hover:bg-teal-500/20">
                Começar Agora
              </Badge>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
                {ctaContent.title}
              </h2>
              
              <p className="text-lg text-slate-300 leading-relaxed">
                {ctaContent.subtitle}
              </p>
            </div>

            {/* Contact Form */}
            <form onSubmit={handleSubmit} className="max-w-xl mx-auto space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="O seu nome"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-5 py-4 rounded-xl bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="O seu email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-5 py-4 rounded-xl bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                />
              </div>
              <textarea
                name="message"
                placeholder="Descreva o que pretende para o seu site (tipo de negócio, funcionalidades, referências, etc.)"
                value={formData.message}
                onChange={handleChange}
                rows={5}
                className="w-full px-5 py-4 rounded-xl bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none"
              />
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-teal-500 hover:bg-teal-400 text-white h-14 px-8 shadow-xl shadow-teal-500/20 hover:shadow-teal-500/30 transition-all duration-300 disabled:opacity-50"
              >
                {isSubmitting ? (
                  'A enviar...'
                ) : (
                  <>
                    {ctaContent.buttonText}
                    <Send className="w-5 h-5 ml-2" />
                  </>
                )}
              </Button>
            </form>

            {/* Features */}
            <div className="flex flex-wrap justify-center gap-6 mt-8">
              {ctaContent.features.map((feature, index) => (
                <div key={index} className="flex items-center gap-2 text-slate-300">
                  <CheckCircle className="w-5 h-5 text-teal-400" />
                  <span className="text-sm">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
